// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"173":"c7f2604e","213":"acfedfd1","287":"7a4ebd4d","455":"3215aa83","586":"47f04841","916":"bee7d38b","919":"71063a8f"}[chunkId] + ".chunk.js";
};